import axios from 'axios';
import toCamelCase from '@/helpers/toCamelCase';

export const state = () => ({
    links: [],
    currentLink: undefined
});

export const getters = {
    links: state => state.links,
    currentLink: state => state.currentLink
};

export const mutations = {
    SET_LINKS(state, links) {
        state.links = links;
    },

    SET_CURRENT_LINK(state, link) {
        state.currentLink = link;
    },

    ADD_LINK(state, link) {
        state.links.push(link);
    },

    UPDATE_LINK(state, link) {
        const index = state.links.findIndex(item => item.id === link.id);

        if (~index) {
            state.links.splice(index, 1, link);
        }
    },
};

export const actions = {
    async getLinks({ commit }) {
        const links = await axios.getMethodOverridePost('/v1/dashboard_shared_links', { encodeURI: true });

        commit('SET_LINKS', toCamelCase(links));

        return links;
    },

    async loadCurrentLink({ commit, dispatch }, { code }) {
        const link = await dispatch('getLinkByCode', {code})

        commit('SET_CURRENT_LINK', link);

        return link;
    },

    async getLinkByCode({ commit }, { code }) {
        const link = await axios.getMethodOverridePost(`/v1/dashboard_shared_links/${code}`, { encodeURI: true });

        commit('ADD_LINK', link);

        return link;
    },

    async createLink({ commit }, { title, widgets, non_logged_in_access, contexts, time, time_range, time_unit }) {
        const config = {
            widgets,
            contexts,
            time,
            time_range,
            time_unit
        };

        const link = await axios.$post('/v1/dashboard_shared_links', { title, non_logged_in_access, config });

        commit('ADD_LINK', link);

        return link;
    },

    async updateLink({ commit }, { id, title, widgets, non_logged_in_access, contexts, time, time_range, time_unit }) {
        const config = {
            widgets,
            contexts,
            time,
            time_range,
            time_unit
        };

        const link = await axios.$put(`/v1/dashboard_shared_links/${id}`, { title, non_logged_in_access, config });

        commit('UPDATE_LINK', link);

        return link;
    }
};
